import { Category } from "./CategoriesList";

/**
 * Flatten the entire category tree so we can easily map
 * each category key to its human-readable name for display.
 */
export function flattenCategories(categories: Category[]): Record<string, string> {
    let map: Record<string, string> = {};
    for (const cat of categories) {
        map[cat.key] = cat.name;
        const subMap = flattenCategories(cat.subcategories);
        map = { ...map, ...subMap };
    }
    return map;
}

/** 
 * Recursively collect ALL category keys (root + subcategories)
 * for "Select All" functionality.
 */
export function getAllCategoryKeys(categories: Category[]): string[] {
    let keys: string[] = [];
    for (const cat of categories) {
        keys.push(cat.key);
        keys = keys.concat(getAllCategoryKeys(cat.subcategories));
    }
    return keys;
}

/**
 * Recursively find a category by its key and return its name.
 * If the category is not found, return `undefined`.
 * 
 * @param categories - The list of categories to search through.
 * @param key - The key of the category to find.
 * @returns The name of the category, or `undefined` if not found.
 */
export function getCategoryName(categories: Category[], key: string): string | undefined {
    for (const category of categories) {
      if (category.key === key) {
        return category.name; // Match found
      }
  
      // Search in subcategories
      const subcategoryName = getCategoryName(category.subcategories, key);
      if (subcategoryName) {
        return subcategoryName; // Return if found in subcategories
      }
    }
  
    // Return undefined if not found
    return undefined;
  }